import { NgModule } from "@angular/core";
import { ResetPasswordFormModule } from "@gloria-public/login/views/components/reset-password-form/reset-password-form.module";
import { ResetPasswordPageComponent } from "./reset-password-page.component";

@NgModule({
  declarations: [ResetPasswordPageComponent],
  imports: [ResetPasswordFormModule],
})
export class ResetPasswordPageModule {}
